import { Color } from './Color';

export const gradients = {
	'gray-background': {
		gradient: `linear-gradient(0deg, ${Color.BackgroundGradientLight}, ${Color.BackgroundGradientLight}), linear-gradient(0deg, ${Color.BodyBackground}, ${Color.BodyBackground});`,
		fallback: Color.BodyBackground,
	},
	'blue-blue': {
		gradient: `linear-gradient( 264.29deg, ${Color.HeaderGradientStart} 0%, ${Color.BlueGradient} 55.5%)`,
		fallback: Color.HeaderGradientStart,
	},
	'blue-blue-mobile': {
		gradient: `linear-gradient(214deg, ${Color.HeaderGradientStart} 0%, ${Color.BlueGradient} 36.07%)`,
		fallback: Color.HeaderGradientStart,
	},
};

export type IGradients = typeof gradients;
export type IGradientName = keyof IGradients;

export function getGradientBackground(gradientName: IGradientName) {
	const { fallback, gradient } = gradients[gradientName];

	return `
		background: ${fallback};
		background: ${gradient};
	`;
}
